import { authFetch, BASE_BACKEND_URL } from '../../../auth'
import React, { useContext, useEffect, useState } from 'react'
import Select from 'react-select'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { BasePromoContext } from '../../context/BasePromoContext'
import { AssortedPromoContext } from '../../context/AssortedPromoContext'
import { BonusPromoContext } from '../../context/BonusPromoContext'
import { AssortedBonusPromoContext } from '../../context/AssortedBonusPromoContext'
import _ from 'lodash'
import { replaceAccentedCharacters } from '../../../helpers/utils'
import WarningTextPromo from '../alerts/WarningTextPromo'
const BRAND_PRODUCT_LIMIT = 500

let countsCache = {
  brand: {}
}

const ProductSection = ({
  promoData,
  cloningPromo,
  setCloningPromo,
  setIsSubmitDisabled,
  appliesTo,
  promoType,
  baseBrand,
  setBaseBrand,
  bonusBrand,
  setBonusBrand,
  isAssorted,
  setPromoRule,
  setPromoScaleArray,
  setCheckedMaxBonus,
  setScaleArray,
  failedCreation,
  setFailedCreation,
  setFailedCreationMessage,
  setNoValidPackages
}) => {
  const [productOptions, setProductOptions] = useState([])
  const [productsForBrands, setProductsForBrands] = useState({})
  const [baseProductSelectionType, setBaseProductSelectionType] = useState('')
  const [bonusProductSelectionType, setBonusProductSelectionType] = useState('')
  const [brandBaseProductCount, setBrandBaseProductCount] = useState('...')
  const [brandBonusProductCount, setBrandBonusProductCount] = useState('...')
  const [brandProductsLimitPassed, setBrandProductsLimitPassed] = useState(false)
  const [selectionSource, setSelectionSource] = useState(null)

  const BASE_PRODUCT = 'baseProduct'
  const BONUS_PRODUCT = 'bonusProduct'

  const {
    baseProducts,
    addBaseProduct,
    changeBasePackageProduct,
    clearBaseProduct,
    changeBaseQuantityProduct
  } = useContext(BasePromoContext)

  const {
    assortedProducts,
    addAssortedProduct,
    changeBasePackageAssortedProducts,
    clearAssortedProducts,
    removeAssortedProduct,
    addAssortedProductQuantity
  } = useContext(AssortedPromoContext)

  const {
    assortedBonusProducts,
    addAssortedBonusProduct,
    addAssortedBonusProductQuantity,
    changeBonusPackageAssortedBonusProducts,
    clearAssortedBonusProducts,
    removeAssortedBonusProduct,
    changeLimitToAssortedBonus
  } = useContext(AssortedBonusPromoContext)

  const {
    bonusProducts,
    addBonusProduct,
    removeBonusProduct,
    changeBonusPackageProduct,
    clearBonusProduct,
    changeBonusQuantityProduct,
    changeLimitToBonus
  } = useContext(BonusPromoContext)

  const isEmptyBrandBaseProductCount =
    brandBaseProductCount !== null &&
    brandBaseProductCount !== undefined &&
    Number(brandBaseProductCount) === 0

  const isEmptyBrandBonusProductCount =
    brandBonusProductCount !== null &&
    brandBonusProductCount !== undefined &&
    Number(brandBonusProductCount) === 0

  const mappedAssortedProducts = assortedProducts
    .map((p) => p.packages)
    .sort((a, b) => a.length - b.length)

  const mappedAssortedBonusProducts = assortedBonusProducts
    .map((p) => p.packages)
    .sort((a, b) => a.length - b.length)

  const noValidPackages =
    (assortedProducts.length === 0 ||
      (assortedProducts.length > 0 && mappedAssortedProducts[0].length === 0) ||
      (assortedProducts.length > 0 &&
        mappedAssortedProducts[0].every((pkg) => pkg.unit == null))) &&
    (baseProducts.length === 0 ||
      (baseProducts.length > 0 && baseProducts[0].packages.length === 0) ||
      (baseProducts.length > 0 && baseProducts[0].packages.every((pkg) => pkg.unit == null)))

  const noValidBonusPackages =
    (assortedBonusProducts.length === 0 ||
      (assortedBonusProducts.length > 0 && mappedAssortedBonusProducts[0].length === 0) ||
      (assortedBonusProducts.length > 0 &&
        mappedAssortedBonusProducts[0].every((pkg) => pkg.unit == null))) &&
    (bonusProducts.length === 0 ||
      (bonusProducts.length > 0 && bonusProducts[0].packages.length === 0) ||
      (bonusProducts.length > 0 && bonusProducts[0].packages.every((pkg) => pkg.unit == null)))

  const onKeyPress = (event) => {
    if (event.which === 13 /* Enter */) {
      event.preventDefault()
    }
  }

  const openUrlNewWindow = (url) => {
    window.open(url, '_blank')
  }

  ////// Stops fetchs when page is changed
  const abortController = new AbortController()
  var abortProductController = new AbortController()
  const abortCurrentFetchs = () => {
    abortProductController.abort('Fetch Aborted by User.')
    abortController.abort('Fetch Aborted by User.')
  }
  window.addEventListener('beforeunload', abortCurrentFetchs)
  //////

  // Stops product fetch when is unfocus
  const abortProductFetchs = () => {
    abortProductController.abort('Fetch Aborted by User.')
  }
  //

  const handleProductSelectTypeChange = (event) => {
    event.preventDefault()
    const obj = {}
    obj[event.target.name] = event.target.value
    // when these values are reset product selected
    // should be reset in order to hide and empty table
    if (event.target.name === 'applies_base_product_selection_type') {
      clearAssortedProducts()
      clearAssortedBonusProducts()
      clearBonusProduct()
      setBaseBrand('')
      setBaseProductSelectionType(obj.applies_base_product_selection_type)
    } else if (event.target.name === 'applies_bonus_product_selection_type') {
      clearAssortedBonusProducts()
      clearBonusProduct()
      setBonusBrand('')
      setBonusProductSelectionType(obj.applies_bonus_product_selection_type)
    }
  }

  const handleBrandsChange = async (event, type) => {
    if (event?.brand) {
      if (type === BASE_PRODUCT) {
        setBaseBrand(event.brand)
        setSelectionSource('brand')
      } else {
        setBonusBrand(event.brand)
      }
      await authFetch(
        `${BASE_BACKEND_URL}/products?by_brand=${event.brand.db_ref}&non_paginated=true&no_refund_packages=true`,
        {
          method: 'GET',
          signal: abortController.signal,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          }
        }
      )
        .then((response) => {
        if (!response) return
        return response.json()
      })
        .then((data) => {
          const selectedProducts = data['table']
          if (selectedProducts) {
            selectedProducts.forEach((pr, index) => {
              paramsToPostToServer(pr, type, isAssorted)
            })
          }
        })
        .catch((error) => {
          if (error !== 'Fetch Aborted by User.') {
            console.error('Error:', error)
          }
        })
    }
  }

  const fetchProductsFromBrand = async (type) => {
    const brand = type === BASE_PRODUCT ? baseBrand : bonusBrand

    if (!brand) return

    try {
      const response = await authFetch(
        `${BASE_BACKEND_URL}/products?by_brand=${brand.db_ref}&non_paginated=true&no_refund_packages=true`,
        {
          method: 'GET',
          signal: abortController.signal,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          }
        }
      )

      if (!response.ok) {
        console.error(`Error al obtener productos para la marca ${brand.db_ref}`)
        return
      }

      const data = await response.json()
      const selectedProducts = data['table']

      if (selectedProducts) {
        selectedProducts.forEach((pr) => {
          paramsToPostToServer(pr, type, isAssorted)
        })
      }
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Error en fetchProductsFromBrand:', error)
      }
    }
  }

  const deleteBrandSelected = (event, type) => {
    if (type === BASE_PRODUCT) {
      clearAssortedProducts()
      setBaseBrand('')
    } else {
      clearAssortedBonusProducts()
      setBonusBrand('')
    }
  }

  const getProductsForBrandsData = () => {
    authFetch(`${BASE_BACKEND_URL}/products/promo_necessary_data`, {
      method: 'GET',
      signal: abortController.signal,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }
    })
      .then((response) => {
        if (!response) return
        return response.json()
      })
      .then((data) => {
        setProductsForBrands(data)
      })
      .catch((error) => {
        if (error !== 'Fetch Aborted by User.') {
          console.error('Error:', error)
        }
      })
  }

  const fetchProducts = (event, type, isAssorted) => {
    event.preventDefault()
    setSelectionSource('input')
    const query = event.target.value
    if (query.length > 2) {
      abortProductController = new AbortController()
      const safeQuery = encodeURIComponent(replaceAccentedCharacters(query))

      authFetch(
        `${BASE_BACKEND_URL}/products?q=${safeQuery}&productactive=true&no_refund_packages=true`,
        {
          method: 'GET',
          signal: abortProductController.signal,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          }
        }
      )
        .then((response) => {
        if (!response) return
        return response.json()
      })
        .then((data) => {
          let result = []
          if (type === BASE_PRODUCT && isAssorted) {
            // index products by "product_db_ref"
            const lookup = _.keyBy(assortedProducts, (o) => o.db_ref)

            /* find all products where "db_ref" exists in index, one loop, quick lookup. no nested loops
                return
               */
            result = _.filter(data['table'], (u) => !lookup[u.db_ref])
          } else if (type === BONUS_PRODUCT && isAssorted) {
            const lookup = _.keyBy(assortedBonusProducts, (o) => o.db_ref)

            /* find all products where "db_ref" exists in index, one loop, quick lookup. no nested loops
                return
               */
            result = _.filter(data['table'], (u) => !lookup[u.db_ref])
          } else {
            result = data['table']
          }
          setProductOptions(result)
        })
        .catch((error) => {
          if (error !== 'Fetch Aborted by User.') {
            console.error('Error:', error)
          }
        })
    }

    const targetValue = event.target.value
    const element = document.getElementsByName(targetValue)[0]

    if (element) {
      const product_id = element.innerText
      if (product_id) {
        const selectedObj = productOptions.filter((obj) => parseInt(product_id) === obj.id)[0]
        if (selectedObj) {
          paramsToPostToServer(selectedObj, type, isAssorted)
          event.target.value = ''
        }
      }
    }
  }

  const paramsToPostToServer = (selectedObj, type, isAssorted) => {
    if (type === BASE_PRODUCT && isAssorted) {
      addAssortedProduct({
        ...selectedObj
      })
    } else if (type === BONUS_PRODUCT && isAssorted) {
      addAssortedBonusProduct({
        ...selectedObj
      })
    } else if (type === BONUS_PRODUCT && !isAssorted) {
      addBonusProduct({
        ...selectedObj
      })
    } else {
      addBaseProduct({
        ...selectedObj
      })
    }
  }

  const renderProductTable = (products, title, deleteFunction, isAssorted = false) => {

    if (!products.length) return null

    const maxPackages = Math.max(...products.map((p) => p.packages?.length || 0))

    return (
      <table className="table-pdv table-hover promo-product-table">
        <thead className="table-header-pdv">
          <tr>
            <th className="pl-20">CODIGO</th>
            <th>NOMBRE DEL PRODUCTO</th>
            {Array.from({ length: maxPackages }).map((_, i) => (
              <th key={i}>UNIDAD DE VENTA {i + 1}</th>
            ))}
            <th className="centered">ACCIÓN</th>
          </tr>
        </thead>
        <tbody>
          {uniqueProductsById(products).map((product, index) => {
            const packages = product.packages || []

            return (
              <tr
                key={`${product.id}-${index}`}
                style={{ background: isAssorted ? '#f6f6f6' : 'white' }}
              >
                <td className="pl-20">{product.db_ref}</td>
                <td>{product.name}</td>

                {Array.from({ length: maxPackages }).map((_, i) => {
                  const pkg = packages[i]
                  return (
                    <td key={`${product.id}-pkg-${i}`}>
                      {pkg
                        ? `${pkg.unit}${pkg.quantity > 1 ? ` de ${pkg.quantity}` : ''}`
                        : '-'}
                    </td>
                  )
                })}

                <td
                  className="delete-selected-product"
                  onClick={(e) => deleteFunction(e, product, isAssorted)}
                >
                  &times;
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    )
  }

  const resetProductSelected = (event) => {
    event.preventDefault()
    clearAssortedProducts()
    clearAssortedBonusProducts()
    clearBaseProduct()
    clearBonusProduct()
  }

  const handleBonusPackageInputChange = (event, isAssorted) => {
    if (isAssorted) {
      const bonusPackage = event.target.value
      changeBonusPackageAssortedBonusProducts({
        bonusPackage: bonusPackage
      })
    } else {
      const bonusPackage = event.target.value
      const getPackage = _.find(bonusProducts[0].packages, { unit: bonusPackage })
      changeBonusPackageProduct({
        bonusPackage: getPackage.unit,
        bonusPackage_uid: getPackage.uid,
        id: bonusProducts[0].id
      })
    }
  }

  const handleBasePackageInputChange = (event) => {
    if (isAssorted) {
      const basePackage = event.target.value
      changeBasePackageAssortedProducts({
        basePackage: basePackage
      })
    } else {
      const basePackage = event.target.value
      const getPackage = _.find(baseProducts[0].packages, { unit: basePackage })
      changeBasePackageProduct({
        basePackage: getPackage.unit,
        basePackage_uid: getPackage.uid,
        basePackageQuantity: getPackage.quantity,
        id: baseProducts[0].id
      })
    }
  }

  const deleteBonusProductFromTable = (event, product, isAssorted) => {
    if (isAssorted) {
      removeAssortedBonusProduct(product)
      if (assortedBonusProducts.length === 0) {
        clearAssortedProducts()
      }
    } else {
      removeBonusProduct(product)
      if (bonusProducts.length === 0) {
        clearBonusProduct()
      }
    }
  }

  const deleteBaseProductFromTable = (event, product, isAssorted) => {
    if (isAssorted) {
      removeAssortedProduct(product)
      if (assortedProducts.length === 0) {
        resetProductSelected()
      }
    } else {
      resetProductSelected()
    }
  }

  const uniqueProductsById = (products) => {
    return [...new Map(products.map((item) => [item['id'], item])).values()]
  }

  const displayBaseProductCount = () => {
    if (brandBaseProductCount == '...') {
      return 'Cargando...'
    }
    let brandCountNum = Number(brandBaseProductCount)
    if (!isNaN(brandCountNum)) {
      return `${brandCountNum} - ${brandCountNum > 1 || brandCountNum == 0 ? 'PRODUCTOS ACTIVOS' : 'PRODUCTO ACTIVO'}`
    }
  }

  const displayBonusProductCount = () => {
    if (brandBonusProductCount == '...') {
      return 'Cargando...'
    }
    let brandCountNum = Number(brandBonusProductCount)
    if (!isNaN(brandCountNum)) {
      return `${brandCountNum} - ${brandCountNum > 1 || brandCountNum == 0 ? 'PRODUCTOS ACTIVOS' : 'PRODUCTO ACTIVO'}`
    }
  }

  const getBaseProductsCount = async () => {
    let type = ''
    let typeData = null
    if (baseBrand) {
      type = 'brand'
      typeData = baseBrand.db_ref
    }
    if (typeData) {
      if (countsCache[type][typeData]) {
        setBrandBaseProductCount(countsCache[type][typeData])
        if (countsCache[type][typeData] > BRAND_PRODUCT_LIMIT) {
          setBrandProductsLimitPassed(true)
        }
      } else {
        setBrandBaseProductCount('...')
        try {
          let resp = await authFetch(
            `${BASE_BACKEND_URL}/products?by_${type}=${typeData}&count_only=true`,
            {
              method: 'GET',
              signal: abortController.signal,
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
              }
            }
          )
          if (resp.status != 200) {
            console.error('Error al obtener el conteo de productos')
            return setBrandBaseProductCount(0)
          }

          let data = await resp.json()
          countsCache[type][typeData] = data.result
          setBrandBaseProductCount(data.result)
          if (
            data.result <= BRAND_PRODUCT_LIMIT ||
            countsCache[type][typeData] <= BRAND_PRODUCT_LIMIT
          ) {
            fetchProductsFromBrand(BASE_PRODUCT)
          } else {
            setBrandProductsLimitPassed(true)
          }
        } catch (error) {
          if (error !== 'Fetch Aborted by User.') {
            console.error('Error:', error)
          }
        }
      }
    } else {
      setBrandBaseProductCount('...')
    }
  }

  const getBonusProductsCount = async () => {
    let type = ''
    let typeData = null

    if (bonusBrand) {
      type = 'brand'
      typeData = bonusBrand.db_ref
    }

    if (typeData) {
      if (countsCache[type]?.[typeData]) {
        setBrandBonusProductCount(countsCache[type][typeData])
        if (countsCache[type][typeData] > BRAND_PRODUCT_LIMIT) {
          setBrandProductsLimitPassed(true)
        }
      } else {
        setBrandBonusProductCount('...')

        try {
          let resp = await authFetch(
            `${BASE_BACKEND_URL}/products?by_${type}=${typeData}&count_only=true`,
            {
              method: 'GET',
              signal: abortController.signal,
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
              }
            }
          )

          if (resp.status !== 200) {
            console.error('Error al obtener el conteo de productos bonificados')
            return setBrandBonusProductCount(0)
          }

          const data = await resp.json()
          countsCache[type][typeData] = data.result
          setBrandBonusProductCount(data.result)

          if (
            data.result <= BRAND_PRODUCT_LIMIT ||
            countsCache[type][typeData] <= BRAND_PRODUCT_LIMIT
          ) {
            fetchProductsFromBrand(BONUS_PRODUCT)
          } else {
            setBrandProductsLimitPassed(true)
          }
        } catch (error) {
          setBrandBonusProductCount(0)
          if (error !== 'Fetch Aborted by User.') {
            console.error('Error:', error)
          }
        }
      }
    } else {
      setBrandBonusProductCount('...')
    }
  }

  const setUpPromo = async () => {
    if (promoData) {
      switch (promoData.promo_type) {
        case 'bonus_product':
          {
            let result = []
            try {
              await authFetch(
                `${BASE_BACKEND_URL}/products?q=${promoData.promotion.base_product_db_ref}&productactive=true&no_refund_packages=true&clone_task=true`,
                {
                  method: 'GET',
                  signal: abortController.signal,
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                  }
                }
              )
                .then((response) => {
        if (!response) return
        return response.json()
      })
                .then((data) => {
                  result = data['table']
                })
                .catch((e) => console.log(e))
              if (result) {
                result.forEach((pr, index) => {
                  paramsToPostToServer(pr, BASE_PRODUCT, isAssorted)
                })
              }
              const getPackage = _.find(result[0].packages, {
                unit: promoData.promotion.base_package
              })
              changeBasePackageProduct({
                basePackage: getPackage.unit,
                basePackage_uid: getPackage.uid,
                basePackageQuantity: getPackage.quantity,
                id: result[0].id
              })
            } catch (e) {
              console.log('Error en duplicacion de promos (BonusProduct Base Product): ', e)
              setFailedCreation(true)
              setFailedCreationMessage(
                'Hubo un error al intentar obtener: El producto base, requerido para crear la copia de la promoción. Por favor, asegúrese de completar todos los campos faltantes en adelante.'
              )
              setTimeout(() => setFailedCreation(false), 15000)
              setIsSubmitDisabled(false)
              return setCloningPromo(false)
            }
            let bonusResult = []
            try {
              await authFetch(
                `${BASE_BACKEND_URL}/products?q=${promoData.promotion.bonus_product_db_ref}&productactive=true&no_refund_packages=true&clone_task=true`,
                {
                  method: 'GET',
                  signal: abortController.signal,
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                  }
                }
              )
                .then((response) => {
        if (!response) return
        return response.json()
      })
                .then((data) => {
                  bonusResult = data['table']
                })
                .catch((e) => console.log(e))
              if (bonusResult) {
                bonusResult.forEach((pr, index) => {
                  paramsToPostToServer(pr, BONUS_PRODUCT, isAssorted)
                })
              }

              const getBonusPackage = _.find(bonusResult[0].packages, {
                unit: promoData.promotion.bonus_package
              })
              changeBonusPackageProduct({
                bonusPackage: getBonusPackage.unit,
                bonusPackage_uid: getBonusPackage.uid,
                id: bonusResult[0].id
              })
            } catch (e) {
              console.log('Error en duplicacion de promos (BonusProduct Bonus product): ', e)
              setFailedCreation(true)
              setFailedCreationMessage(
                'Hubo un error al intentar obtener: El producto bonificado, requerido para crear la copia de la promoción. Por favor, asegúrese de completar todos los campos faltantes en adelante.'
              )
              setTimeout(() => setFailedCreation(false), 15000)
              setIsSubmitDisabled(false)
              return setCloningPromo(false)
            }
            try {
              switch (promoData.promotion.promo_rule_type) {
                case 'one_increment':
                  {
                    setPromoRule('one_increment')
                    const baseQuantity = promoData.promotion.base_quantity
                    changeBaseQuantityProduct({
                      baseQuantity: baseQuantity,
                      id: result[0].id
                    })
                    const bonusQuantity = promoData.promotion.bonus_quantity
                    changeBonusQuantityProduct({
                      bonusQuantity: bonusQuantity,
                      id: bonusResult[0].id
                    })
                    const maxLimit = promoData.promotion.bonus_limit
                    changeLimitToBonus({
                      maxLimit: maxLimit,
                      id: bonusResult[0].id
                    })

                    if (maxLimit > 0) {
                      setCheckedMaxBonus(true)
                    }
                  }
                  break
                case 'scale':
                  {
                    setPromoRule('scale')
                    setPromoScaleArray(promoData.promotion.promo_scale_array)
                  }
                  break
              }
            } catch (e) {
              console.log('Error en duplicacion de promos (BonusProduct Promo Rule): ', e)
              setFailedCreation(true)
              setFailedCreationMessage(
                'Hubo un error al intentar obtener: La regla de la promoción, requerida para crear la copia de la promoción. Por favor, asegúrese de completar todos los campos faltantes en adelante.'
              )
              setTimeout(() => setFailedCreation(false), 15000)
              setIsSubmitDisabled(false)
              return setCloningPromo(false)
            }
          }
          break
        case 'assorted_scale_discount_product':
          {
            let result = []
            try {
              if (promoData.promotion?.base_brand?.length > 0) {
                setBaseProductSelectionType('brands')
                let _brand = await productsForBrands?.brand?.find(
                  (b) => b.db_ref === promoData.promotion.base_brand
                )
                setBaseBrand(_brand)
                await authFetch(
                  `${BASE_BACKEND_URL}/products?by_brand=${promoData.promotion.base_brand}&non_paginated=true&no_refund_packages=true`,
                  {
                    method: 'GET',
                    signal: abortController.signal,
                    headers: {
                      Accept: 'application/json',
                      'Content-Type': 'application/json',
                    }
                  }
                )
                  .then((response) => {
        if (!response) return
        return response.json()
      })
                  .then((data) => {
                    const selectedProducts = data['table']
                    result = data['table']
                    if (selectedProducts) {
                      selectedProducts.forEach((pr, index) => {
                        paramsToPostToServer(pr, BASE_PRODUCT, isAssorted)
                      })
                    }
                  })
                  .catch((e) => console.log('Error al obtener productos de marca.', e))
              } else {
                setBaseProductSelectionType('products')
                for (const productDfRef of promoData.promotion.base_product_uids) {
                  await authFetch(
                    `${BASE_BACKEND_URL}/products?q=${productDfRef}&productactive=true&no_refund_packages=true&clone_task=true`,
                    {
                      method: 'GET',
                      signal: abortController.signal,
                      headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                      }
                    }
                  )
                    .then((response) => {
        if (!response) return
        return response.json()
      })
                    .then((data) => {
                      result = data['table']
                    })
                    .catch((e) => console.log(e))
                  if (result) {
                    result.forEach((pr, index) => {
                      paramsToPostToServer(pr, BASE_PRODUCT, isAssorted)
                    })
                  }
                }
              }
              let basePackage = null
              for (const unit of promoData.promotion.base_package_units) {
                let index = _.findIndex(result[0].packages, { unit: unit })
                if (index > -1) {
                  basePackage = index
                  break
                }
              }
              changeBasePackageAssortedProducts({
                basePackage: basePackage
              })
            } catch (e) {
              console.log('Error en duplicacion de promos (Discount base products): ', e)
              setFailedCreation(true)
              setFailedCreationMessage(
                'Hubo un error al intentar obtener: Los productos base, requeridos para crear la copia de la promoción. Por favor, asegúrese de completar todos los campos faltantes en adelante.'
              )
              setTimeout(() => setFailedCreation(false), 15000)
              setIsSubmitDisabled(false)
              return setCloningPromo(false)
            }
            try {
              setScaleArray(promoData.promotion.scale_discount_hash)
            } catch (e) {
              console.log('Error en duplicacion de promos (Discount promo rule): ', e)
              setFailedCreation(true)
              setFailedCreationMessage(
                'Hubo un error al intentar obtener: La regla de promoción, requerida para crear la copia de la promoción. Por favor, asegúrese de completar todos los campos faltantes en adelante.'
              )
              setTimeout(() => setFailedCreation(false), 15000)
              setIsSubmitDisabled(false)
              return setCloningPromo(false)
            }
          }
          break
        case 'assorted_bonus_product':
          {
            let result = []
            try {
              if (promoData.promotion?.base_brand?.length > 0) {
                setBaseProductSelectionType('brands')
                let _brand = await productsForBrands?.brand?.find(
                  (b) => b.db_ref === promoData.promotion.base_brand
                )
                setBaseBrand(_brand)
                await authFetch(
                  `${BASE_BACKEND_URL}/products?by_brand=${promoData.promotion.base_brand}&non_paginated=true&no_refund_packages=true`,
                  {
                    method: 'GET',
                    signal: abortController.signal,
                    headers: {
                      Accept: 'application/json',
                      'Content-Type': 'application/json',
                    }
                  }
                )
                  .then((response) => {
        if (!response) return
        return response.json()
      })
                  .then((data) => {
                    const selectedProducts = data['table']
                    result = data['table']
                    if (selectedProducts) {
                      selectedProducts.forEach((pr, index) => {
                        paramsToPostToServer(pr, BASE_PRODUCT, isAssorted)
                      })
                    }
                  })
                  .catch((e) => console.log('Error al obtener productos de marca.', e))
              } else {
                setBaseProductSelectionType('products')
                for (const productDfRef of promoData.promotion.base_product_uids) {
                  await authFetch(
                    `${BASE_BACKEND_URL}/products?q=${productDfRef}&productactive=true&no_refund_packages=true&clone_task=true`,
                    {
                      method: 'GET',
                      signal: abortController.signal,
                      headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                      }
                    }
                  )
                    .then((response) => {
        if (!response) return
        return response.json()
      })
                    .then((data) => {
                      result = data['table']
                    })
                    .catch((e) => console.log(e))
                  if (result) {
                    result.forEach((pr, index) => {
                      paramsToPostToServer(pr, BASE_PRODUCT, isAssorted)
                    })
                  }
                }
              }
              let basePackage = null
              for (const unit of promoData.promotion.base_package_units) {
                let index = _.findIndex(result[0].packages, { unit: unit })
                if (index > -1) {
                  basePackage = index
                  break
                }
              }
              changeBasePackageAssortedProducts({
                basePackage: basePackage
              })
            } catch (e) {
              console.log('Error en duplicacion de promos (AssortedBonusProduct base product): ', e)
              setFailedCreation(true)
              setFailedCreationMessage(
                'Hubo un error al intentar obtener: Los productos base, requeridos para crear la copia de la promoción. Por favor, asegúrese de completar todos los campos faltantes en adelante.'
              )
              setTimeout(() => setFailedCreation(false), 15000)
              setIsSubmitDisabled(false)
              return setCloningPromo(false)
            }
            let bonusResult = []

            try {
              if (promoData.promotion?.bonus_brand?.length > 0) {
                setBonusProductSelectionType('brands')
                let _brand = await productsForBrands?.brand?.find(
                  (b) => b.db_ref === promoData.promotion.bonus_brand
                )
                setBonusBrand(_brand)
                setSelectionSource('brand')
                await authFetch(
                  `${BASE_BACKEND_URL}/products?by_brand=${promoData.promotion.bonus_brand}&non_paginated=true&no_refund_packages=true`,
                  {
                    method: 'GET',
                    signal: abortController.signal,
                    headers: {
                      Accept: 'application/json',
                      'Content-Type': 'application/json',
                    }
                  }
                )
                  .then((response) => {
        if (!response) return
        return response.json()
      })
                  .then((data) => {
                    bonusResult = data['table']
                    bonusResult.forEach((pr) => {
                      paramsToPostToServer(pr, BONUS_PRODUCT, isAssorted)
                    })
                  })
                  .catch((e) => console.log('Error al obtener productos de marca bonificada.', e))
              } else {
                setBonusProductSelectionType('products')
                setSelectionSource('input')
                for (const productDfRef of promoData.promotion.bonus_product_uids) {
                  await authFetch(
                    `${BASE_BACKEND_URL}/products?q=${productDfRef}&productactive=true&no_refund_packages=true&clone_task=true`,
                    {
                      method: 'GET',
                      signal: abortController.signal,
                      headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                      }
                    }
                  )
                    .then((response) => {
        if (!response) return
        return response.json()
      })
                    .then((data) => {
                      bonusResult = data['table']
                    })
                    .catch((e) => console.log(e))
                  if (bonusResult) {
                    bonusResult.forEach((pr) => {
                      paramsToPostToServer(pr, BONUS_PRODUCT, isAssorted)
                    })
                  }
                }
              }

              let bonusPackage = null
              for (const unit of promoData.promotion.bonus_package_units) {
                let index = _.findIndex(bonusResult[0].packages, { unit: unit })
                if (index > -1) {
                  bonusPackage = index
                  break
                }
              }
              changeBonusPackageAssortedBonusProducts({
                bonusPackage: bonusPackage
              })
            } catch (e) {
              console.log(
                'Error en duplicación de promos (AssortedBonusProduct bonus product): ',
                e
              )
              setFailedCreation(true)
              setFailedCreationMessage(
                'Hubo un error al intentar obtener: Los productos bonificados, requeridos para crear la copia de la promoción. Por favor, asegúrese de completar todos los campos faltantes en adelante.'
              )
              setTimeout(() => setFailedCreation(false), 15000)
              setIsSubmitDisabled(false)
              return setCloningPromo(false)
            }
            try {
              switch (promoData.promotion.promo_rule_type) {
                case 'one_increment':
                  {
                    setPromoRule('one_increment')
                    const baseQuantity = promoData.promotion.base_quantity
                    addAssortedProductQuantity({
                      baseQuantity: baseQuantity,
                      id: result[0].id
                    })

                    const bonusQuantity = promoData.promotion.bonus_quantity
                    addAssortedBonusProductQuantity({
                      bonusQuantity: bonusQuantity,
                      id: bonusResult[0].id
                    })
                    const maxLimit = promoData.promotion.bonus_limit
                    changeLimitToAssortedBonus({
                      maxLimit: maxLimit,
                      id: bonusResult[0].id
                    })

                    if (maxLimit > 0) {
                      setCheckedMaxBonus(true)
                    }
                  }
                  break
                case 'scale':
                  {
                    setPromoRule('scale')
                    setPromoScaleArray(promoData.promotion.promo_scale_array)
                  }
                  break
              }

            } catch (e) {
              console.log('Error en duplicacion de promos (AssortedBonusProduct promo rule): ', e)
              setFailedCreation(true)
              setFailedCreationMessage(
                'Hubo un error al intentar obtener: La regla de promoción, requerida para crear la copia de la promoción. Por favor, asegúrese de completar todos los campos faltantes en adelante.'
              )
              setTimeout(() => setFailedCreation(false), 15000)
              setIsSubmitDisabled(false)
              return setCloningPromo(false)
            }
          }
          break
      }

      setCloningPromo(false)
      setIsSubmitDisabled(false)

      if (noValidPackages) {
        return
      }

    }
  }

  useEffect(() => {
    getProductsForBrandsData()
  }, [])

  useEffect(() => {
    if (promoData) {
      setUpPromo()
    }
  }, [promoData, productsForBrands.brand])

  useEffect(() => {
    setBrandProductsLimitPassed(false)
    getBaseProductsCount()
  }, [baseBrand])

  useEffect(() => {
    const requiresBonus = promoType === 'bonus_product' || promoType === 'assorted_bonus_product'
    setNoValidPackages(noValidPackages || (requiresBonus && noValidBonusPackages))
  }, [promoType, noValidPackages, noValidBonusPackages, setNoValidPackages])

  useEffect(() => {
    setBrandProductsLimitPassed(false)
    getBonusProductsCount()
  }, [bonusBrand])

  if (cloningPromo) {
    return null
  }

  return (
    <>
      <div className="promo-card">
        <div className="title-promos-form">
          {isAssorted ? <b>3. Producto(s) base</b> : <b>3. Producto base</b>}
        </div>
        <hr className="hr-promo-card" />

        {isAssorted && appliesTo.length === 0 && (
          <>
            <p className="promo-card-subtitle">
              3.1: Escoja la base de la promoción, por producto(s) o marca
            </p>
            <div>
              <select
                className="select-promo-type form-control custom-select inactive"
                name="applies_base_product_selection_type"
                required
                disabled
              >
                <option value="" hidden>
                  Escoger una opcion
                </option>
              </select>
            </div>
          </>
        )}

        {isAssorted && appliesTo.length !== 0 && (
          <>
            <p className="promo-card-subtitle">
              3.1: Escoja la base de la promoción, por producto(s) o marca
            </p>
            <div>
              <select
                onChange={handleProductSelectTypeChange}
                className="select-promo-type form-control custom-select"
                name="applies_base_product_selection_type"
                placeholder="Escoja una opción"
                value={baseProductSelectionType}
                required
              >
                <option value="" hidden>
                  {' '}
                  Escoja una opción{' '}
                </option>
                <option value="products">Producto</option>
                <option value="brands">Marcas</option>
              </select>
            </div>
          </>
        )}

        {/* Punto 3.2 Seleccion de producto base para bonificacion */}
        {isAssorted &&
          appliesTo.length !== 0 &&
          baseProductSelectionType === 'products' &&
          assortedProducts.length === 0 && (
            <>
              <p className="promo-card-subtitle mt-15">
                3.2: Escoja los producto(s) para la base de esta promoción
              </p>
              <div className="input-wrapper">
                <input
                  autoComplete="off"
                  onChange={(e) => fetchProducts(e, BASE_PRODUCT, isAssorted)}
                  onKeyPress={onKeyPress}
                  className="search-input-border form-control"
                  placeholder="Escribir nombre o codigo del producto"
                  list="all-products"
                  onBlur={abortProductFetchs}
                  required
                />
                <FontAwesomeIcon className="input-icon " icon={faSearch} />
              </div>
            </>
          )}
        {isAssorted && baseProductSelectionType === 'products' && assortedProducts.length > 0 && (
          <>
            <p className="promo-card-subtitle mt-15">
              3.2: Escoja los producto(s) para la base de esta promoción
            </p>
            <div className="input-wrapper">
              <input
                autoComplete="off"
                onChange={(e) => fetchProducts(e, BASE_PRODUCT, isAssorted)}
                onKeyPress={onKeyPress}
                className="search-input-border form-control"
                placeholder="Escribir nombre o codigo del producto"
                list="all-products"
                onBlur={abortProductFetchs}
              />
              <FontAwesomeIcon className="input-icon " icon={faSearch} />
            </div>
          </>
        )}
        {!isAssorted && appliesTo.length === 0 && (
          <>
            <p className="promo-card-subtitle">
              3.1: Escoja el producto para la base de esta promoción
            </p>
            <div className="input-wrapper">
              <input
                autoComplete="off"
                onChange={(e) => fetchProducts(e, BASE_PRODUCT, isAssorted)}
                onKeyPress={onKeyPress}
                className="search-input-border form-control inactive"
                placeholder="Escribir nombre o codigo del producto"
                list="all-products"
                required
                onBlur={abortProductFetchs}
                disabled
              />
              <FontAwesomeIcon className="input-icon inactive" icon={faSearch} />
            </div>
          </>
        )}
        {!isAssorted && appliesTo.length !== 0 && baseProducts.length === 0 && (
          <>
            <p className="promo-card-subtitle">
              3.1: Escoja el producto para la base de esta promoción
            </p>
            <div className="input-wrapper">
              <input
                autoComplete="off"
                onChange={(e) => fetchProducts(e, BASE_PRODUCT, isAssorted)}
                onKeyPress={onKeyPress}
                className="search-input-border form-control"
                placeholder="Escribir nombre o codigo del producto"
                list="all-products"
                onBlur={abortProductFetchs}
                required
              />
              <FontAwesomeIcon className="input-icon " icon={faSearch} />
            </div>
          </>
        )}
        {!isAssorted && baseProducts.length > 0 && (
          <>
            <p className="promo-card-subtitle">
              3.1: Escoja el producto para la base de esta promoción
            </p>
            <div className="input-wrapper">
              <input
                autoComplete="off"
                onChange={(e) => fetchProducts(e, BASE_PRODUCT, isAssorted)}
                onKeyPress={onKeyPress}
                className="search-input-border form-control inactive"
                placeholder="Escribir nombre o codigo del producto"
                list="all-products"
                onBlur={abortProductFetchs}
                disabled
              />
              <FontAwesomeIcon className="input-icon inactive " icon={faSearch} />
            </div>
          </>
        )}
        <datalist id="all-products">
          {productOptions?.map((obj, index) => (
            <option
              key={index}
              id={obj.id}
              name={obj.db_ref + ' - ' + obj.name}
              value={obj.db_ref + ' - ' + obj.name}
            >
              {obj.id}
            </option>
          ))}
        </datalist>

        {isAssorted &&
          baseProductSelectionType === 'products' &&
          renderProductTable(
            assortedProducts,
            'Productos Surtidos',
            deleteBaseProductFromTable,
            true
          )}

        {!isAssorted && renderProductTable(baseProducts, 'Productos Base', resetProductSelected)}

        {/* Punto 3.2 Seleccion de marca base para bonificacion */}
        {appliesTo.length !== 0 && baseProductSelectionType === 'brands' && isAssorted && (
          <>
            {!baseBrand && (
              <>
                <p className="promo-card-subtitle mt-25">
                  3.2: Escoja la marca para la base de esta promoción
                </p>
                <div className="form-control-width">
                  <div className="fake-validator-container">
                    <input
                      className="input-fake-validator"
                      type="text"
                      required
                      value={baseBrand?.db_ref ? baseBrand?.db_ref : null}
                    />
                    <Select
                      placeholder={'Escoja una opcion'}
                      noOptionsMessage={() => 'No hay resultados'}
                      loadingMessage={() => 'Cargando...'}
                      className="brand-select"
                      isClearable={false}
                      value={baseBrand ? { value: baseBrand.db_ref, label: baseBrand.name } : null}
                      onChange={(e) => handleBrandsChange(e, BASE_PRODUCT)}
                      options={productsForBrands?.brand?.map((option) => {
                        return { value: option.db_ref, label: option.name, brand: option }
                      })}
                    />
                  </div>
                </div>
              </>
            )}
            {baseBrand && (
              <>
                <p className="promo-card-subtitle mt-25">
                  3.2: Escoja la marca para la base de esta promoción
                </p>
                <div className="form-control-width">
                  <div className="fake-validator-container">
                    <input
                      className="input-fake-validator"
                      type="text"
                      disabled
                      value={baseBrand?.db_ref ? baseBrand?.db_ref : null}
                    />
                    <Select
                      placeholder={'Escoja una opcion'}
                      noOptionsMessage={() => 'No hay resultados'}
                      loadingMessage={() => 'Cargando...'}
                      className="brand-select"
                      isClearable={false}
                      isDisabled={true}
                      value={baseBrand ? { value: baseBrand.db_ref, label: baseBrand.name } : null}
                      onChange={(e) => handleBrandsChange(e, BASE_PRODUCT)}
                      options={productsForBrands?.brand?.map((option) => {
                        return { value: option.db_ref, label: option.name, brand: option }
                      })}
                    />
                  </div>
                </div>
              </>
            )}
            {baseBrand?.db_ref && (
              <div className="box-products-preview-container">
                <div className="box-products-preview mr-10">
                  <p style={{ margin: 0 }} title={baseBrand?.name}>
                    {displayBaseProductCount()}
                  </p>
                  <div
                    onClick={(e) => deleteBrandSelected(e, BASE_PRODUCT)}
                    className="delete-selected-product"
                  >
                    &times;
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() =>
                    openUrlNewWindow(
                      `/productos?by_brand=${baseBrand.db_ref}&brand_name=${baseBrand.name}`
                    )
                  }
                  className="big-btn"
                >
                  Ver listado de productos
                </button>
              </div>
            )}
            {baseBrand?.db_ref && brandProductsLimitPassed && (
              <p className="warning-brand-product-limit-text">
                No es posible crear una promoción con marcas que tienen más de 500 productos. Elige
                una marca diferente con menos productos para continuar.
              </p>
            )}
          </>
        )}

        <div>
          {isEmptyBrandBaseProductCount && (
            <>
              {baseProductSelectionType === 'brands' ? (
                <p className="promo-card-subtitle mt-60">3.3: Seleccione la unidad de venta</p>
              ) : (
                <p className="promo-card-subtitle mt-33">3.2: Seleccione la unidad de venta</p>
              )}
              <div>
                <select
                  className={`select-promo-type form-control custom-select ${assortedProducts.length === 0 && baseProducts.length === 0
                    ? 'select-disabled-promo form-control custom-select'
                    : ''
                    }`}
                  name="base_package_promo"
                  value={
                    isAssorted
                      ? _.findIndex(assortedProducts[0]?.packages, {
                        unit: assortedProducts[0]?.base_package
                      })
                      : baseProducts[0]?.base_package
                  }
                  required
                  disabled
                >
                  <option value="" hidden>
                    Escoja una opción
                  </option>
                </select>
              </div>

              {noValidPackages && selectionSource === 'brand' && (
                <WarningTextPromo type="brand" />
              )}
              {noValidPackages && selectionSource === 'input' && (
                <WarningTextPromo type="product" />

              )}
            </>
          )}
        </div>

        {(assortedProducts.length > 0 || baseProducts.length > 0) && (
          <>
            {baseProductSelectionType === 'brands' ? (
              <p className="promo-card-subtitle mt-50">3.3: Seleccione la unidad de venta</p>
            ) : (
              <p className="promo-card-subtitle mt-15">3.3: Seleccione la unidad de venta</p>
            )}
            <div>
              <select
                onChange={(e) => handleBasePackageInputChange(e)}
                className="select-promo-type form-control custom-select"
                name="base_package_promo"
                value={
                  isAssorted
                    ? _.findIndex(assortedProducts[0]?.packages, {
                      unit: assortedProducts[0]?.base_package
                    })
                    : baseProducts[0]?.base_package
                }
                required
              >
                <option value="" hidden>
                  Escoja una opción
                </option>
                {assortedProducts.length > 0 &&
                  assortedProducts
                    .map((p) => p.packages)
                    .sort(function (a, b) {
                      return a.length - b.length
                    })[0]
                    .map((obj, index) => (
                      <option key={obj.id} id={obj.id} name={obj.unit} value={index}>
                        {`Unidad de venta ${index + 1}`}
                      </option>
                    ))}
                {baseProducts.length > 0 &&
                  baseProducts[0]?.packages.map((obj, index) => (
                    <option key={obj.id} id={obj.id} name={obj.unit} value={obj.unit}>
                      {`Unidad de venta ${index + 1}`}
                    </option>
                  ))}
              </select>
            </div>
            {noValidPackages && selectionSource === 'brand' && (
              <WarningTextPromo type="brand" />

            )}
            {noValidPackages && selectionSource === 'input' && (
              <WarningTextPromo type="product" />

            )}
          </>
        )}
      </div>

      {promoType != 'assorted_scale_discount_product' && (
        <div className="promo-card">
          <div className="title-promos-form">
            {isAssorted ? <b>4. Producto(s) bonificado(s)</b> : <b>4. Producto bonificado</b>}
          </div>
          <hr className="hr-promo-card" />

          {!isAssorted && baseProducts.length === 0 && (
            <>
              <p className="promo-card-subtitle">
                4.1: Escoja el producto a bonificar para esta promoción
              </p>
              <div className="input-wrapper">
                <input
                  autoComplete="off"
                  onChange={fetchProducts}
                  onKeyPress={onKeyPress}
                  className="search-input-border form-control inactive"
                  list="all-products"
                  placeholder="Escribir nombre o codigo del producto"
                  required
                  disabled
                />
                <FontAwesomeIcon className="input-icon inactive" icon={faSearch} />
              </div>
            </>
          )}
          {isAssorted && assortedProducts.length === 0 && (
            <>
              <p className="promo-card-subtitle">
                4.1: Escoja los productos a bonificar para esta promoción, por producto(s) o marca
              </p>
              <div>
                <select
                  className="select-promo-type form-control custom-select inactive"
                  name="applies_bonus_product_selection_type"
                  required
                  disabled
                >
                  <option value="" hidden>
                    Escoger una opcion
                  </option>
                </select>
              </div>
            </>
          )}

          {isAssorted && assortedProducts.length > 0 && (
            <>
              <p className="promo-card-subtitle">
                4.1: Escoja los productos a bonificar para esta promoción, por producto(s) o marca
              </p>
              <div>
                <select
                  onChange={handleProductSelectTypeChange}
                  className="select-promo-type form-control custom-select"
                  name="applies_bonus_product_selection_type"
                  placeholder="Escoja una opción"
                  value={bonusProductSelectionType}
                  required
                >
                  <option value="" hidden>
                    {' '}
                    Escoja una opción{' '}
                  </option>
                  <option value="products">Producto</option>
                  <option value="brands">Marcas</option>
                </select>
              </div>
            </>
          )}

          {isAssorted &&
            assortedProducts.length > 0 &&
            bonusProductSelectionType === 'products' &&
            assortedBonusProducts.length === 0 && (
              <>
                <p className="promo-card-subtitle mt-33">
                  4.2: Escoja los producto(s) a bonificar para esta promoción
                </p>
                <div className="input-wrapper">
                  <input
                    autoComplete="off"
                    onChange={(e) => fetchProducts(e, BONUS_PRODUCT, isAssorted)}
                    onKeyPress={onKeyPress}
                    className="search-input-border"
                    placeholder="Escribir nombre o codigo del producto"
                    list="all-products"
                    required
                  />
                  <FontAwesomeIcon className="input-icon" icon={faSearch} />
                </div>
              </>
            )}
          {isAssorted &&
            bonusProductSelectionType === 'products' &&
            assortedBonusProducts.length > 0 && (
              <>
                <p className="promo-card-subtitle mt-33">
                  4.2: Escoja los producto(s) a bonificar para esta promoción
                </p>
                <div className="input-wrapper">
                  <input
                    autoComplete="off"
                    onChange={(e) => fetchProducts(e, BONUS_PRODUCT, isAssorted)}
                    onKeyPress={onKeyPress}
                    className="search-input-border"
                    placeholder="Escribir nombre o codigo del producto"
                    list="all-products"
                  />
                  <FontAwesomeIcon className="input-icon" icon={faSearch} />
                </div>
              </>
            )}

          {baseProducts.length > 0 && bonusProducts.length === 0 && (
            <>
              <p className="promo-card-subtitle">
                4.1: Escoja el producto a bonificar para esta promoción
              </p>
              <div className="input-wrapper">
                <input
                  autoComplete="off"
                  onChange={(e) => fetchProducts(e, BONUS_PRODUCT, isAssorted)}
                  onKeyPress={onKeyPress}
                  className="search-input-border"
                  placeholder="Escribir nombre o codigo del producto"
                  list="all-products"
                  required
                />
                <FontAwesomeIcon className="input-icon" icon={faSearch} />
              </div>
            </>
          )}
          {!isAssorted && bonusProducts.length > 0 && (
            <>
              <p className="promo-card-subtitle">
                4.1: Escoja el producto a bonificar para esta promoción
              </p>
              <div className="input-wrapper">
                <input
                  autoComplete="off"
                  onChange={(e) => fetchProducts(e, BONUS_PRODUCT, isAssorted)}
                  onKeyPress={onKeyPress}
                  className="search-input-border form-control inactive"
                  placeholder="Escribir nombre o codigo del producto"
                  list="all-products"
                  disabled
                />
                <FontAwesomeIcon className="input-icon inactive" icon={faSearch} />
              </div>
            </>
          )}
          <datalist id="all-products">
            {productOptions?.map((obj, index) => (
              <option
                key={index}
                id={obj.id}
                name={obj.db_ref + ' - ' + obj.name}
                value={obj.db_ref + ' - ' + obj.name}
              >
                {obj.id}
              </option>
            ))}
          </datalist>

          {!isAssorted &&
            bonusProducts.length > 0 &&
            renderProductTable(bonusProducts, 'Productos Bonificados', deleteBonusProductFromTable)}

          {isAssorted &&
            bonusProductSelectionType === 'products' &&
            assortedBonusProducts.length > 0 &&
            renderProductTable(assortedBonusProducts, '', deleteBonusProductFromTable, true)}

          {assortedProducts.length > 0 && bonusProductSelectionType === 'brands' && isAssorted && (
            <>
              {!bonusBrand && (
                <>
                  <p className="promo-card-subtitle mt-33">
                    4.2: Escoja la marca a bonificar para esta promoción
                  </p>
                  <div className="form-control-width">
                    <div className="fake-validator-container">
                      <input
                        className="input-fake-validator"
                        type="text"
                        required
                        value={bonusBrand?.db_ref ? bonusBrand?.db_ref : null}
                      />
                      <Select
                        placeholder={'Escoja una opcion'}
                        noOptionsMessage={() => 'No hay resultados'}
                        loadingMessage={() => 'Cargando...'}
                        className="brand-select"
                        isClearable={false}
                        value={
                          bonusBrand ? { value: bonusBrand.db_ref, label: bonusBrand.name } : null
                        }
                        onChange={(e) => handleBrandsChange(e, BONUS_PRODUCT)}
                        options={productsForBrands?.brand?.map((option) => {
                          return { value: option.db_ref, label: option.name, brand: option }
                        })}
                      />
                    </div>
                  </div>
                </>
              )}
              {bonusBrand && (
                <>
                  <p className="promo-card-subtitle mt-33">
                    4.2: Escoja la marca a bonificar para esta promoción
                  </p>
                  <div className="form-control-width">
                    <div className="fake-validator-container">
                      <input
                        className="input-fake-validator"
                        type="text"
                        disabled
                        value={bonusBrand?.db_ref ? bonusBrand?.db_ref : null}
                      />
                      <Select
                        placeholder={'Escoja una opcion'}
                        noOptionsMessage={() => 'No hay resultados'}
                        loadingMessage={() => 'Cargando...'}
                        className="brand-select"
                        isClearable={false}
                        isDisabled={true}
                        value={
                          bonusBrand ? { value: bonusBrand.db_ref, label: bonusBrand.name } : null
                        }
                        onChange={(e) => handleBrandsChange(e, BONUS_PRODUCT)}
                        options={productsForBrands?.brand?.map((option) => {
                          return { value: option.db_ref, label: option.name, brand: option }
                        })}
                      />
                    </div>
                  </div>
                </>
              )}
              {bonusBrand?.db_ref && (
                <div className="box-products-preview-container">
                  <div className="box-products-preview mr-10">
                    <p style={{ margin: 0 }} title={baseBrand?.name}>
                      {displayBonusProductCount()}
                    </p>
                    <div
                      onClick={(e) => deleteBrandSelected(e, BONUS_PRODUCT)}
                      className="delete-selected-product"
                    >
                      &times;
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={() =>
                      openUrlNewWindow(
                        `/productos?by_brand=${bonusBrand.db_ref}&brand_name=${bonusBrand.name}`
                      )
                    }
                    className="big-btn"
                  >
                    Ver listado de productos
                  </button>
                </div>
              )}

              {bonusBrand?.db_ref && brandProductsLimitPassed && (
                <p className="warning-brand-product-limit-text">
                  No es posible crear una promoción con marcas que tienen más de 500 productos.
                  Elige una marca diferente con menos productos para continuar.
                </p>
              )}
            </>
          )}

          <div>
            {isEmptyBrandBonusProductCount && (
              <>
                {bonusProductSelectionType === 'brands' ? (
                  <p className="promo-card-subtitle mt-60">4.3: Seleccione la unidad de venta</p>
                ) : (
                  <p className="promo-card-subtitle mt-33">4.2: Seleccione la unidad de venta</p>
                )}
                <div>
                  <select
                    className={`select-promo-type ${assortedBonusProducts.length === 0 && bonusProducts.length === 0
                      ? 'select-disabled-promo'
                      : ''
                      }`}
                    name="bonus_package_promo"
                    value={
                      isAssorted
                        ? _.findIndex(assortedBonusProducts[0]?.packages, {
                          unit: assortedBonusProducts[0]?.bonus_package
                        })
                        : bonusProducts[0]?.bonus_package
                    }
                    required
                    disabled
                  >
                    <option value="" hidden>
                      Escoja una opción
                    </option>
                  </select>
                </div>

                {noValidBonusPackages && bonusProductSelectionType === 'brands' && (
                  <WarningTextPromo type="brand" />

                )}
                {noValidBonusPackages && bonusProductSelectionType === 'products' && (
                  <WarningTextPromo type="product" />

                )}
              </>
            )}
          </div>

          {(assortedBonusProducts.length > 0 || bonusProducts.length > 0) && (
            <>
              {assortedBonusProducts.length > 0 ? (
                <p className="promo-card-subtitle mt-33">4.3: Seleccione la unidad de venta</p>
              ) : (
                <p className="promo-card-subtitle mt-33">4.2: Seleccione la unidad de venta</p>
              )}
              <div>
                <select
                  onChange={(e) => handleBonusPackageInputChange(e, isAssorted)}
                  className="select-promo-type form-control custom-select"
                  name="base_package_promo"
                  value={
                    isAssorted
                      ? _.findIndex(assortedBonusProducts[0].packages, {
                        unit: assortedBonusProducts[0].bonus_package
                      })
                      : bonusProducts[0].bonus_package
                  }
                  required
                >
                  <option value="" hidden>
                    Escoja una opción
                  </option>
                  {assortedBonusProducts.length > 0 &&
                    assortedBonusProducts
                      .map((p) => p.packages)
                      .sort(function (a, b) {
                        return a.length - b.length
                      })[0]
                      .map((obj, index) => (
                        <option key={obj.id} id={obj.id} name={obj.unit} value={index}>
                          {`Unidad de venta ${index + 1}`}
                        </option>
                      ))}
                  {bonusProducts.length > 0 &&
                    bonusProducts[0]?.packages.map((obj, index) => (
                      <option key={obj.id} id={obj.id} name={obj.unit} value={obj.unit}>
                        {`Unidad de venta ${index + 1}`}
                      </option>
                    ))}
                </select>
              </div>

              {noValidBonusPackages && isAssorted && bonusProductSelectionType === 'brands' && (
                <WarningTextPromo type="brand" />
              )}
              {noValidBonusPackages && isAssorted && bonusProductSelectionType === 'products' && (
                <WarningTextPromo type="product" />

              )}
            </>
          )}
        </div>
      )}
    </>
  )
}
export default ProductSection
